/**
 * @desc Controller for the csBreadcrumbsNav directive
 */
;(function () {
  angular
    .module('contrast.breadcrumbs-nav')
    .factory('csBreadcrumbsNavService', [csBreadcrumbsNavService])

  function csBreadcrumbsNavService() {
    return {
      getDefaultKnobSettings: getDefaultKnobSettings,
      getCircles: getCircles
    }

    function getDefaultKnobSettings() {
      return {
        value: 1,
        options: {
          skin: {
            type: 'tron',
            width: 10,
            color: '#e7e7e7',
            spaceWidth: 3
          },
          animate: {
            enabled: true,
            duration: 500,
            ease: 'linear'
          },
          readOnly: true,
          barColor: '#E6F5F6',
          trackWidth: 30,
          barWidth: 30,
          step: 1,
          max: 100,
          displayInput: false,
          size: 100,
          hoopScale: 0.35
        }
      }
    }

    function getCircles(routes, initialRouteIndex, separation, clickFn) {
      var circles = [],
        route = null

      for (var i = 0; i < routes.length; i++) {
        route = routes[i]

        circles.push({
          cx: 50,
          cy: 10 + i * separation,
          r: 8,
          link: route.route,
          url: route.path,
          enabled: route.enabled,
          clickFn: clickFn
        })
      }

      circles.push({
        cx: 50,
        cy: 10 + initialRouteIndex * separation,
        r: 8,
        link: routes[initialRouteIndex].route,
        url: routes[initialRouteIndex].path,
        active: true,
        linkActive: true
      })

      return circles
    }
  }
})()
